module.exports = __webpack_public_path__ + "media/images/restaurant/areas/shikoku_m-b4bfded47a70d18796b9f2a2326c1289.png";